import React from "react";

function IconTemplateSave(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.27389 1.7739C4.74273 1.30506 5.37862 1.04167 6.04166 1.04167H13.5417C14.2047 1.04167 14.8406 1.30506 15.3094 1.7739C15.7783 2.24274 16.0417 2.87863 16.0417 3.54167V17.9167C16.0417 18.1628 15.8972 18.386 15.6727 18.4868C15.4482 18.5876 15.1854 18.5473 15.0014 18.3838L9.79166 13.7529L4.58188 18.3838C4.39793 18.5473 4.13514 18.5876 3.91062 18.4868C3.6861 18.386 3.54166 18.1628 3.54166 17.9167V3.54167C3.54166 2.87862 3.80505 2.24274 4.27389 1.7739ZM6.04166 2.29167C5.71014 2.29167 5.39219 2.42336 5.15777 2.65778C4.92335 2.8922 4.79166 3.21015 4.79166 3.54167V16.5249L9.37643 12.4495C9.61323 12.239 9.97008 12.239 10.2069 12.4495L14.7917 16.5249V3.54167C14.7917 3.21015 14.66 2.8922 14.4255 2.65778C14.1911 2.42336 13.8732 2.29167 13.5417 2.29167H6.04166Z"
        fill="#424242"
      />
    </svg>
  );
}

export default IconTemplateSave;
